<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top mobile-ver-top-2">
                <div class="d-flex align-items-center h-100 justify-content-between px-3">
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('dashboard_student')">
                            <i class="fa-solid fa-arrow-left"></i>
                        </a>
                        <div class="d-block display-tektur h1 m-0">Rasionalisasi</div>
                    </div>
                </div>
            </div>
            <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                <div class="d-block">
                    <div v-if="dataFetch" class="d-block mb-4">
                        <p class="text-center mt-5">Loading...</p>
                    </div>

                    <div v-if="!dataFetch">
                        <div v-if="!dataRationalization.id" data-simplebar class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                            <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                                <div class="d-block mb-3">
                                    <div class="card-body">
                                        <div class="d-block text-center p-md-4">
                                            <div class="d-block text-center">
                                                <div class="d-block mb-2 display-tektur text-md">Kamu belum menentukan pilihan jurusan</div>
                                                <div class="d-block">Silahkan tentukan pilihan jurusan untuk mengisi rapor. Klik tombol dibawah ini untuk atur jurusan.</div>
                                                <div class="d-block">
                                                    <a href="javascript:void(0)" class="btn btn-s-1 btn-primary mt-5" v-on:click="goToPage('student_settings_major')">
                                                        <div class="btn-s-1-inner"><i class="fa-solid fa-pen me-2"></i> Atur Pilihan</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="dataRationalization.id">
                            <div v-if="!dataRationalization.score_list" data-simplebar class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                                <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                                    <div class="d-block mb-3">
                                        <div class="card-body">
                                            <div class="d-block text-center p-md-4">
                                                <div class="d-block text-center">
                                                    <div class="d-block mb-2 display-tektur text-md">Kamu belum mengisi detail rapor</div>
                                                    <div class="d-block">Silahkan untuk mengisi rapor terlebih dahulu. Klik tombol dibawah ini untuk mengisi rapor.</div>
                                                    <div class="d-block">
                                                        <a href="javascript:void(0)" class="btn btn-s-1 btn-primary mt-5" v-on:click="goToPage('student_rapor')">
                                                            <div class="btn-s-1-inner"><i class="fa-solid fa-pen me-2"></i> Isi Rapor</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="dataRationalization.score_list">
                                <div class="d-block mb-4">
                                    <div class="d-block subtitle-sticky bg-blue-bokeh py-3 px-md-4 px-3">
                                        <div class="d-block font-bold h3 m-0"><i
                                                class="fa-solid fa-caret-right text-pink me-2"></i>Pilihan Kamu</div>
                                    </div>
                                    
                                    <div class="d-block px-md-4 px-3 pt-3">
                                        <div v-for="(item, index) in dataEvaluation" :key="index" class="card mb-3">
                                            <div class="card-body">
                                                <div class="row mb-md-0 mb-3">
                                                    <div class="col-md-7 col-12 mb-md-0 mb-3">
                                                        <div class="d-block mb-4 font-bold text-neon title-style-1">
                                                            <span>Pilihan {{ ++index == '1' ? 'Pertama':'Kedua' }}</span>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <div class="d-block me-3">
                                                                <div class="avatar avatar-xs">
                                                                    <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                                            class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                                                </div>
                                                            </div>
                                                            <div class="d-block overflow-hidden">
                                                                <div class="block-ellipsis h4 m-0 font-bold">{{ item.major_fullname }}</div>
                                                                <div class="block-ellipsis h5">{{item.university_name}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-12 hide-767">
                                                        <div class="d-flex justify-content-end">
                                                            <div class="d-block me-3">
                                                                <div class="d-block mb-3 text-sm text-center">Index<br/>Nilai</div>
                                                                <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_score}}%</div>
                                                            </div>
                                                            <div class="d-block me-3">
                                                                <div class="d-block mb-3 text-sm text-center">Index Pendukung</div>
                                                                <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_support}}%</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="show-767">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <div class="card bg-dblue border m-0">
                                                                <div class="d-block p-3 text-center">
                                                                    <div class="d-block mb-2 text-sm">Index<br/>Nilai</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="card bg-dblue border m-0">
                                                                <div class="d-block p-3 text-center">
                                                                    <div class="d-block mb-2 text-sm">Index Pendukung</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_support}}%
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="pt-4">
                                                    <a href="javascript:void(0)" v-on:click="goDetail(item.id,'')"
                                                        class="btn btn-s-1 btn-primary btn-block w-100">
                                                        <div class="btn-s-1-inner">Detail</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-block mb-4">
                                    <div class="d-block subtitle-sticky bg-blue-bokeh py-3 px-md-4 px-3">
                                        <div class="d-flex align-items-center justify-content-between cursor-pointer" v-on:click="collapse_alternative_major = !collapse_alternative_major" style="cursor:pointer;">
                                            <div class="d-block font-bold h3 m-0">
                                                <i class="fa-solid fa-caret-right text-pink me-2"></i>Alternatif Sesuai Jurusan
                                            </div>
                                            <div class="d-block">
                                                <i :class="collapse_alternative_major ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="collapse_alternative_major">
                                        <div v-if="dataFetchAltMajor" class="d-block mb-4">
                                            <p class="text-center mt-5">Loading...</p>
                                        </div>

                                        <div v-if="!dataFetchAltMajor" class="d-block px-md-4 px-3 pt-3">
                                            <div v-for="(item, index) in dataAltMajor.alt_one" :key="index" class="card mb-3">
                                                <div class="card-body">
                                                    <div class="row mb-md-0 mb-3">
                                                        <div class="col-md-7 col-12 mb-md-0 mb-3">
                                                            <div class="d-block mb-4 font-bold text-neon title-style-1 text-sm">
                                                                <span>Rekomendasi Sesuai Jurusan Pertama</span>
                                                            </div>
                                                            <div class="d-flex align-items-center">
                                                                <div class="d-block me-3">
                                                                    <div class="avatar avatar-xs">
                                                                        <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                                                class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                                                    </div>
                                                                </div>
                                                                <div class="d-block overflow-hidden">
                                                                    <div class="block-ellipsis h4 m-0 font-bold">{{ item.major_fullname }}</div>
                                                                    <div class="block-ellipsis h5">{{item.university_name}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5 col-12 hide-767">
                                                            <div class="d-flex justify-content-end">
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index<br/>Nilai</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_score}}%</div>
                                                                </div>
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index Pendukung</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_support}}%</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="show-767">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index<br/>Nilai</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index Pendukung</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_support}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pt-4">
                                                        <a href="javascript:void(0)" v-on:click="goDetail(item.id,'major')"
                                                            class="btn btn-s-1 btn-primary btn-block w-100">
                                                            <div class="btn-s-1-inner">Detail</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-for="(item, index) in dataAltMajor.alt_two" :key="index" class="card mb-3">
                                                <div class="card-body">
                                                    <div class="row mb-md-0 mb-3">
                                                        <div class="col-md-7 col-12 mb-md-0 mb-3">
                                                            <div class="d-block mb-4 font-bold text-neon title-style-1 text-sm">
                                                                <span>Rekomendasi Sesuai Jurusan Kedua</span>
                                                            </div>
                                                            <div class="d-flex align-items-center">
                                                                <div class="d-block me-3">
                                                                    <div class="avatar avatar-xs">
                                                                        <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                                                class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                                                    </div>
                                                                </div>
                                                                <div class="d-block overflow-hidden">
                                                                    <div class="block-ellipsis h4 m-0 font-bold">{{ item.major_fullname }}</div>
                                                                    <div class="block-ellipsis h5">{{item.university_name}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5 col-12 hide-767">
                                                            <div class="d-flex justify-content-end">
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index<br/>Nilai</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_score}}%</div>
                                                                </div>
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index Pendukung</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_support}}%</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="show-767">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index<br/>Nilai</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index Pendukung</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_support}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pt-4">
                                                        <a href="javascript:void(0)" v-on:click="goDetail(item.id,'major')"
                                                            class="btn btn-s-1 btn-primary btn-block w-100">
                                                            <div class="btn-s-1-inner">Detail</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="fetchLoadMoreAltMajor" class="d-block mb-4">
                                            <p class="text-center mt-5">Loading...</p>
                                        </div>

                                        <div v-if="(!fetchLoadMoreAltMajor && show_filter_alt_major)" class="d-block px-md-4 px-3 pt-3">
                                            <a href="javascript:void(0)" class="btn btn-s-1 btn-primary btn-block w-100" v-on:click="loadMoreAltMajor()">
                                                <div class="btn-s-1-inner"><i class="fa-solid fa-arrow-down me-2"></i> Muat Lebih Banyak</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block mb-4">
                                    <div class="d-block subtitle-sticky bg-blue-bokeh py-3 px-md-4 px-3">
                                        <div class="d-flex align-items-center justify-content-between cursor-pointer" v-on:click="collapse_alternative_group_subject = !collapse_alternative_group_subject" style="cursor:pointer;">
                                            <div class="d-block font-bold h3 m-0">
                                                <i class="fa-solid fa-caret-right text-pink me-2"></i>Alternatif Sesuai Rumpun
                                            </div>
                                            <div class="d-block">
                                                <i :class="collapse_alternative_group_subject ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="collapse_alternative_group_subject">
                                        <div v-if="dataFetchAltGroupMajor" class="d-block mb-4">
                                            <p class="text-center mt-5">Loading...</p>
                                        </div>

                                        <div v-if="!dataFetchAltGroupMajor" class="d-block px-md-4 px-3 pt-3">
                                            <div v-for="(item, index) in dataAltGroupSubject.alt_one" :key="index" class="card mb-3">
                                                <div class="card-body">
                                                    <div class="row mb-md-0 mb-3">
                                                        <div class="col-md-7 col-12 mb-md-0 mb-3">
                                                            <div class="d-block mb-4 font-bold text-neon title-style-1 text-sm">
                                                                <span>Rekomendasi Sesuai Rumpun Pertama</span>
                                                            </div>
                                                            <div class="d-flex align-items-center">
                                                                <div class="d-block me-3">
                                                                    <div class="avatar avatar-xs">
                                                                        <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                                                class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                                                    </div>
                                                                </div>
                                                                <div class="d-block overflow-hidden">
                                                                    <div class="block-ellipsis h4 m-0 font-bold">{{ item.major_fullname }}</div>
                                                                    <div class="block-ellipsis h5">{{item.university_name}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5 col-12 hide-767">
                                                            <div class="d-flex justify-content-end">
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index<br/>Nilai</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_score}}%</div>
                                                                </div>
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index Pendukung</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_support}}%</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="show-767">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index<br/>Nilai</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index Pendukung</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_support}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pt-4">
                                                        <a href="javascript:void(0)" v-on:click="goDetail(item.id,'group_subject')"
                                                            class="btn btn-s-1 btn-primary btn-block w-100">
                                                            <div class="btn-s-1-inner">Detail</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-for="(item, index) in dataAltGroupSubject.alt_two" :key="index" class="card mb-3">
                                                <div class="card-body">
                                                    <div class="row mb-md-0 mb-3">
                                                        <div class="col-md-7 col-12 mb-md-0 mb-3">
                                                            <div class="d-block mb-4 font-bold text-neon title-style-1 text-sm">
                                                                <span>Rekomendasi Sesuai Rumpun Kedua</span>
                                                            </div>
                                                            <div class="d-flex align-items-center">
                                                                <div class="d-block me-3">
                                                                    <div class="avatar avatar-xs">
                                                                        <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                                                class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                                                    </div>
                                                                </div>
                                                                <div class="d-block overflow-hidden">
                                                                    <div class="block-ellipsis h4 m-0 font-bold">{{ item.major_fullname }}</div>
                                                                    <div class="block-ellipsis h5">{{item.university_name}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-5 col-12 hide-767">
                                                            <div class="d-flex justify-content-end">
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index<br/>Nilai</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_score}}%</div>
                                                                </div>
                                                                <div class="d-block me-3">
                                                                    <div class="d-block mb-3 text-sm text-center">Index Pendukung</div>
                                                                    <div class="d-block text-lg display-tektur m-0 text-pink text-center">{{item.index_support}}%</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="show-767">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index<br/>Nilai</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-6">
                                                                <div class="card bg-dblue border m-0">
                                                                    <div class="d-block p-3 text-center">
                                                                        <div class="d-block mb-2 text-sm">Index Pendukung</div>
                                                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_support}}%
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pt-4">
                                                        <a href="javascript:void(0)" v-on:click="goDetail(item.id,'group_subject')"
                                                            class="btn btn-s-1 btn-primary btn-block w-100">
                                                            <div class="btn-s-1-inner">Detail</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="fetchLoadMoreAltGroupMajor" class="d-block mb-4">
                                            <p class="text-center mt-5">Loading...</p>
                                        </div>

                                        <div v-if="(!fetchLoadMoreAltGroupMajor && show_filter_alt_group_subject)" class="d-block px-md-4 px-3 pt-3">
                                            <a href="javascript:void(0)" class="btn btn-s-1 btn-primary btn-block w-100" v-on:click="loadMoreAltGroupSubject()">
                                                <div class="btn-s-1-inner"><i class="fa-solid fa-arrow-down me-2"></i> Muat Lebih Banyak</div>
                                            </a>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentRationalization',
    metaInfo: {
        title: 'Rasionalisasi',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            emptyState              : false,
            dataFetch               : false,
            dataFetchAltMajor       : false,
            fetchLoadMoreAltMajor       : false,
            fetchLoadMoreAltGroupMajor       : false,
            dataFetchAltGroupMajor   : false,
            dataRationalization     : [],
            dataAltMajor            : [],
            dataMoreAltMajor            : [],
            dataMoreAltGroupSubject            : [],
            show_filter_alt_major        : true,
            show_filter_alt_group_subject        : true,
            filter_alt_major : {
                page    : 1,
                limit   : 3
            },
            filter_alt_group_subject : {
                page    : 1,
                limit   : 3
            },
            dataEvaluation          : [],
            dataAltGroupSubject     : [],
            collapse_alternative_major : false,
            collapse_alternative_group_subject : false,
        }
    },
    created() {
        this.getData();
    },
    methods: {
        goToPage: function (params = null) {
            this.$router.push({
                name: params
            })
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/my_rapor';

            this.dataFetch  = true;                
            this.$http.get(uri).then(res => {
                this.dataFetch              = false;
                this.dataRationalization    = res.data.data;

                if(this.dataRationalization.score_list) {
                    this.getEvaluation();
                    this.getEvaluationAltMajor();
                    this.getEvaluationAltGroupSubject();
                }
            });
        },
        loadMoreAltMajor: function() {
            this.filter_alt_major.page += 1;
            this.fetchLoadMoreAltMajor = true;

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.dataRationalization.code,
                    type    : 'major',
                    university_one    : this.dataRationalization.university_one,
                    major_one         : this.dataRationalization.major_one,
                    university_two    : this.dataRationalization.university_two,    
                    major_two         : this.dataRationalization.major_two,
                    page    : this.filter_alt_major.page,
                    limit   : this.filter_alt_major.limit
                }
            }).then(res => {
                this.fetchLoadMoreAltMajor      = false;
                if(res.data.status) {
                    this.dataMoreAltMajor    = res.data.data;
                    this.dataAltMajor.alt_one = [...this.dataAltMajor.alt_one, ...this.dataMoreAltMajor.alt_one];
                    this.dataAltMajor.alt_two = [...this.dataAltMajor.alt_two, ...this.dataMoreAltMajor.alt_two];
                } else {
                    this.show_filter_alt_major = false;
                }
                
             });
        },
        loadMoreAltGroupSubject: function() {
            this.filter_alt_group_subject.page += 1;
            this.fetchLoadMoreAltGroupMajor = true;

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.dataRationalization.code,
                    type    : 'group_subject',
                    university_one    : this.dataRationalization.university_one,
                    major_one         : this.dataRationalization.major_one,
                    university_two    : this.dataRationalization.university_two,    
                    major_two         : this.dataRationalization.major_two,
                    page    : this.filter_alt_group_subject.page,
                    limit   : this.filter_alt_group_subject.limit
                }
            }).then(res => {
                this.fetchLoadMoreAltGroupMajor      = false;
                if(res.data.status) {
                    this.dataMoreAltGroupSubject    = res.data.data;
                    this.dataAltGroupSubject.alt_one = [...this.dataAltGroupSubject.alt_one, ...this.dataMoreAltGroupSubject.alt_one];
                    this.dataAltGroupSubject.alt_two = [...this.dataAltGroupSubject.alt_two, ...this.dataMoreAltGroupSubject.alt_two];
                } else {
                    this.show_filter_alt_group_subject = false;
                }
             });
        },
        getEvaluation: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation';
            this.$http.get(uri,{
                params : {
                    code    : this.dataRationalization.code
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataEvaluation    = res.data.data.evaluation;
                }
             });
        },
        getEvaluationAltMajor: function() {
            this.dataFetchAltMajor      = true;
            this.dataAltMajor           = [];

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.dataRationalization.code,
                    type    : 'major',
                    university_one    : this.dataRationalization.university_one,
                    major_one         : this.dataRationalization.major_one,
                    university_two    : this.dataRationalization.university_two,    
                    major_two         : this.dataRationalization.major_two,
                    page    : this.filter_alt_major.page,
                    limit   : this.filter_alt_major.limit
                }
            }).then(res => {
                this.dataFetchAltMajor      = false;
                if(res.data.status) {
                    this.dataAltMajor    = res.data.data;
                }
             });
        },
        getEvaluationAltGroupSubject: function() {
            this.dataFetchAltGroupSubject      = true;
            this.dataAltGroupSubject           = [];

            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alternative';
            this.$http.get(uri,{
                params : {
                    code    : this.dataRationalization.code,
                    type    : 'group_subject',
                    university_one    : this.dataRationalization.university_one,
                    major_one         : this.dataRationalization.major_one,
                    university_two    : this.dataRationalization.university_two,    
                    major_two         : this.dataRationalization.major_two,
                    page    : this.filter_alt_group_subject.page,
                    limit   : this.filter_alt_group_subject.limit
                }
            }).then(res => {
                this.dataFetchAltGroupSubject      = false;
                if(res.data.status) {
                    this.dataAltGroupSubject    = res.data.data;
                }
             });
        },
        goDetail: function(id, type="") {
            this.$router.push({
                name : 'student_rationalization_detail',
                params: { id: id, code: this.dataRationalization.code },
                query : {
                    type : type
                }
            });
        },
    }
}
</script>
